import { useContext } from 'react';

import { MessageContext } from '@/helpers/MessageProvider';

const useGPSCommand = () => {
  const { publishCommand } = useContext(MessageContext);

  const sendRTCM = (robot, flags, chunk) => {
    publishCommand(robot, 'gps/send_rtcm', [[flags, chunk.length, chunk]]);
  };

  return { sendRTCM };
};

export default useGPSCommand;
